import { isSameDay } from '@dwellet/dwellet-utils';
import { SubmissionError } from 'redux-form';
import i18n from '../../translations/i18n';
import { ReservableShowing, Showing, CreateShowing, FormShowing } from '../../types/showings';
import { valueExistsInArray } from '../arrays';
import { isShowingWithinTimeRange } from '../dates';
// import { getShowingsTimesFromSpesificDate } from '../showings'
const checkShowingsForForApplicationId = (showings: Showing[], applicationId: string) => showings.forEach((showing: Showing) => {
    if (showing.applicationIds) {
        if (valueExistsInArray(showing.applicationIds, applicationId)) {
            throw new Error(`Application exists in showings`);
        }
    }
});
const validateNoEmptyReservables = (reservables: ReservableShowing[], bestReservables: ReservableShowing[]) => {
    if (reservables.length < 1 && bestReservables.length < 1) {
        throw new SubmissionError({
            _error: i18n.t('showings.reserve.noReservables')
        });
    }
};
/** if generateCreateShowings is given showings that are too short min, CreateShowings can be an empty array */
const validateNoEmptyShowingsArray = (showings: CreateShowing[] | Showing[] | FormShowing[]) => {
    if (!showings || showings.length < 1) {
        throw new SubmissionError({
            _error: `tooShort`
        });
    }
};
/** Showing has to be on same day and within 8 AM and 9 PM   */
const validateShowingTimes = ({ startDate, endDate }: CreateShowing | FormShowing, isAdmin = false) => {
    /** 8am. ignores date, only uses minutes  */
    const earliestAllowedTime = '2019-06-18T05:00:00.000Z';
    /** 9pm. ignores date, only uses minutes  */
    const latestAllowedShowingTime = '2019-06-18T18:00:00.000Z';
    if (!isShowingWithinTimeRange(startDate, endDate, earliestAllowedTime, latestAllowedShowingTime)) {
        localStorage.setItem("phoneShowingPickingError", "true");
        throw new SubmissionError({
            _error: 'tooEarlyOrLate'
        });
    }
    if (!isSameDay(new Date(startDate), new Date(endDate))) {
        throw new SubmissionError({
            _error: 'maxOneDay'
        });
    }
    // if (
    //   !isInFutureSameTimeZone(
    //     Date.parse(startDate)
    //   )) {
    //   throw new SubmissionError({
    //     _error: 'allowOnlyFutureEvents'
    //   })
    // }
    const existingError = localStorage.getItem("phoneShowingPickingError");
    if (existingError !== null) {
        localStorage.setItem("phoneShowingPickingError", "false");
    }
};
/** Checks if showing overlaps with existing using moment.range,
 *
 * Note! Make sure to add other createShowings into existingShowings
 * Ensures that createShowings are validated against each others */
// const validateNoDuplicates = (
//   createShowing: CreateShowing | FormShowing,
//   existingShowings: (Showing | CreateShowing | FormShowing)[]
// ) => {
//   const duplicates: boolean = arrayContainsTime(
//     getShowingsTimesFromSpesificDate(existingShowings, createShowing.startDate),
//     createShowing.startDate
//   )
//   if (duplicates) {
//     throw new SubmissionError({
//       _error: 'conflictsWithExisting'
//     })
//   }
// }
const validateCreateShowings = (createShowings: FormShowing[] | CreateShowing[], isAdmin = false
// existingShowings: (Showing | FormShowing | CreateShowing)[]
): void => {
    createShowings.forEach((createShowing: FormShowing | CreateShowing) => {
        validateShowingTimes(createShowing, isAdmin);
        /** used to make sure created showings aren't duplicates but don't validate against itself */
        // const allNewExceptCurrent = createShowings.filter(
        //   (showing: FormShowing | CreateShowing) => showing !== createShowing
        // )
        // validateNoDuplicates(createShowing, [...existingShowings, ...allNewExceptCurrent])
    });
};
export { checkShowingsForForApplicationId, validateNoEmptyReservables, validateNoEmptyShowingsArray, validateCreateShowings };
